export const formattingText = (text: string) => {
  return typeof text === 'string'
    ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    : text
}
